import { render } from "./PhoneNumberFromProspects.vue?vue&type=template&id=110c67cf&scoped=true"
import script from "./PhoneNumberFromProspects.vue?vue&type=script&lang=js"
export * from "./PhoneNumberFromProspects.vue?vue&type=script&lang=js"

import "./PhoneNumberFromProspects.vue?vue&type=style&index=0&id=110c67cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110c67cf"]])

export default __exports__